import TopBar from './components/TopBar';
import Hero from './components/Hero';
import Boards from './components/Boards';
import Feed from './components/Feed';
import Categories from './components/Categories';
import FeatureFlow from './components/FeatureFlow';
import Ranking from './components/Ranking';
import Download from './components/Download';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#fdfaf6] text-stone-900 antialiased">
      <TopBar />
      <main>
        <Hero />
        <Boards />
        <Feed />
        <Categories />
        <FeatureFlow />
        <Ranking />
        <Download />
      </main>
      <Footer />
    </div>
  );
}